import React from "react";
import { Home, History, Edit, Clock } from "lucide-react";
import type { Page } from "../../controller/mobile/types";

interface BottomNavProps {
  active: Extract<Page, "home" | "capture" | "history" | "izin" | "izinlist" | "lembur" | "lemburlist" | "profile" | "none">;
  onNavigate: (page: Extract<Page, "home" | "capture" | "history" | "izin" | "izinlist" | "lembur" | "lemburlist" | "none">) => void;
  onTap: () => {}
}

export default function BottomNav({
  active,
  onNavigate,
  onTap
}: BottomNavProps): React.ReactElement {
  const items: { page: Extract<Page, "home" | "capture" | "history" | "izin" | "izinlist" | "lembur" | "lemburlist" | "none">; label: string; icon: React.ReactNode }[] = [
    { page: "home", label: "Beranda", icon: <Home className="h-5 w-5" /> },
    { page: "history", label: "Riwayat", icon: <History className="h-5 w-5" /> },
    { page: "izin", label: "Izin", icon: <Edit className="h-5 w-5" /> },
    { page: "lembur", label: "Lembur", icon: <Clock className="h-5 w-5" /> }
  ];

  return (
    <nav className="shrink-0 border-t border-slate-200 bg-white px-6 py-2">
      <div className="flex items-center justify-around">
        {items.map((item) => {
          const isActive = active === item.page;
          return (
            <button
              key={item.page}
              type="button"
              onClick={() => { onNavigate(item.page); onTap(); }}
              className={`flex flex-col items-center gap-1 rounded-xl px-4 py-2 text-xs font-medium transition-colors ${
                isActive
                  ? "text-slate-900"
                  : "text-slate-400 hover:text-slate-600"
              }`}
            >
              {item.icon}
              {item.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}